import React, { useState } from "react";
import mainlogo from "./img/SustainabilityProLogo.png";
import registerimg from "./img/register.jpg";
import username from "./img/usernameicon.png";
import keyicon from "./img/keyicon.png";
import eye from "./img/eye.png";
import hidden from "./img/hidden.png";
import mobileicon from "./img/mobile.png";
import emailicon from "./img/email.png";
import { Link, useNavigate } from "react-router-dom";
import { create } from "./services/upload-files.service";

export default function Register() {
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [showPass, setShowPass] = useState(false);
  const [showConfPass, setShowConfPass] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((preData) => ({
      ...preData,
      [name]: value,
      username: formData.email,
    }));
    setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleShowPassword = () => {
    setShowPass(!showPass);
  };
  const handleShowConfPassword = () => {
    setShowConfPass(!showConfPass);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateFormFields(formData);
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
    } else {
      try {
        const res = await create(formData, "register");
        if (res && res.affectedRows > 0) {
          setValidationErrors({ success: "Successfully registered" });
          setTimeout(() => {
            const route = "/";
            navigate(route, { state: { user: res } });
          }, 1000);
        } else {
          setValidationErrors({ err: "Please enter a valid information" });
        }
      } catch (error) {
        setValidationErrors({
          err: "An error occurred. Please try again later",
        });
      }
      setFormData({});
    }
  };

  const validateFormFields = (formData) => {
    const errors = {};
    if (!formData.firstname || formData.firstname.trim() === "") {
      errors.firstname = "Please Enter First Name";
    }else if (!/^[A-Za-z]+$/.test(formData.firstname)) {
      errors.firstname = "First Name Should Contain Only Letters";
    }

    if (!formData.lastname || formData.lastname.trim() === "") {
      errors.lastname = "Please Enter Last Name";
    }else if (!/^[A-Za-z]+$/.test(formData.lastname)) {
      errors.lastname = "Last Name Should Contain Only Letters";
    }

    if (!formData.email || formData.email.trim() === "") {
      errors.email = "Please Enter an Email Address";
    } else if (!validateEmail(formData.email)) {
      errors.email = "Please Enter a Valid Email Address";
    }

    if (!formData.mobile || formData.mobile.trim() === "") {
      errors.mobile = "Please Enter a Mobile Number";
    }  else if (!/^\d{10}$/.test(formData.mobile ,10)) {
      errors.mobile = "Please Enter a Valid 10-digit Mobile Number";
    }

    if (!formData.password || formData.password.trim() === "") {
      errors.password = "Please Enter a Password";
    }

    if (!formData.cpassword || formData.cpassword.trim() === "") {
      errors.cpassword = "Please Confirm Your Password";
    } else if (formData.password !== formData.cpassword) {
      errors.cpassword = "Passwords Do Not Match";
    }

    return errors;
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const validateMobileNumber = (mobileNumber) => {
    const mobileNumberRegex = /^\d{10}$/;
    return mobileNumberRegex.test(mobileNumber);
  };

  return (
    <div className="container register-container">
      <div className="row">
        {/* <div className="col-md-4 px-0">
          <img src={registerimg} className='registerimg' alt="profile_img" />
        </div> */}
        <div className="col-md-12 login-form">
          <img src={mainlogo} alt="sus logo" />
          <form onSubmit={handleSubmit} className="form-custom register-form">
            {validationErrors.success && (
              <div className="success">{validationErrors.success}</div>
            )}

            <div className="input-group">
              <label htmlFor="fname">
                First Name<em>*</em>
              </label>
              <span className="input-group-text">
                <img src={username} className="usernameicon" alt="name icon" />
              </span>
              <input
                type="text"
                className="form-control"
                name="firstname"
                value={formData.firstname || ""}
                onChange={handleInputChange}
              />
              {validationErrors.firstname && (
                <div className="error login-error">
                  {validationErrors.firstname}
                </div>
              )}
            </div>

            <div className="input-group">
              <label htmlFor="lname">
                Last Name<em>*</em>
              </label>
              <span className="input-group-text">
                <img src={username} className="usernameicon" alt="name icon" />
              </span>
              <input
                type="text"
                className="form-control"
                name="lastname"
                value={formData.lastname || ""}
                onChange={handleInputChange}
              />
              {validationErrors.lastname && (
                <div className="error login-error">
                  {validationErrors.lastname}
                </div>
              )}
            </div>

            <div className="input-group">
              <label htmlFor="email">
                Email<em>*</em>
              </label>
              <span className="input-group-text">
                <img src={emailicon} alt="email icon" />
              </span>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email || ""}
                onChange={handleInputChange}
              />
              {validationErrors.email && (
                <div className="error login-error">
                  {validationErrors.email}
                </div>
              )}
            </div>

            <div className="input-group">
              <label htmlFor="mnumber">Mobile Number<em>*</em></label>
              <span className="input-group-text">
                <img src={mobileicon} alt="mobile number icon" />
              </span>
              <input
                type="text"
                className="form-control"
                name="mobile"
                value={formData.mobile || ""}
                onChange={handleInputChange}
              />
              {validationErrors.mobile && (
                <div className="error login-error">
                  {validationErrors.mobile}
                </div>
              )}
            </div>

            <div className="input-group">
              <label htmlFor="password">
                Password<em>*</em>
              </label>
              <span className="input-group-text">
                <img src={keyicon} alt="key icon" />
              </span>
              <input
                type={showPass ? "text" : "password"}
                className="form-control"
                name="password"
                value={formData.password || ""}
                onChange={handleInputChange}
              />
              <i className="input-group-text">
                <img
                  src={showPass ? eye : hidden}
                  alt="key icon"
                  onClick={handleShowPassword}
                />
              </i>

              {validationErrors.password && (
                <div className="error login-error">
                  {validationErrors.password}
                </div>
              )}
            </div>

            <div className="input-group">
              <label htmlFor="password">
                Confirm Password<em>*</em>
              </label>
              <span className="input-group-text">
                <img src={keyicon} alt="key icon" />
              </span>
              <input
                type={showConfPass ? "text" : "password"}
                className="form-control"
                name="cpassword"
                value={formData.cpassword || ""}
                onChange={handleInputChange}
              />
              <i className="input-group-text">
                <img
                  src={showConfPass ? eye : hidden}
                  alt="key icon"
                  onClick={handleShowConfPassword}
                />
              </i>
              {validationErrors.cpassword && (
                <div className="error login-error">
                  {validationErrors.cpassword}
                </div>
              )}
            </div>
            <div className="input-group">
              <button type="submit" className="btn btn-primary btn-add mt-2">
                Submit
              </button>
            </div>
          </form>
          <div className="not-a-member-yet">
            <span>Already Registerd</span>
            <Link to="/">Login here</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
